import { Alert, Typography } from 'antd';
import { Link } from 'react-router-dom';

import useTypedParams from '../../hooks/useTypedParams';
import { JobPostingDetail } from '../../types';
import Form from '../Form';

interface MissingAdmissionDataAlertProps {
  jobPostingId: JobPostingDetail['id'];
}

const MissingAdmissionDataAlert = ({ jobPostingId }: MissingAdmissionDataAlertProps) => {
  const { tenant } = useTypedParams({ tenant: String });

  return (
    <Form.Item>
      <Alert
        message={
          <Typography.Text>
            <Typography.Text strong>Atenção:</Typography.Text> Alguns dados obrigatórios da vaga não
            foram preenchidos. Para prosseguir com o processo de admissão da Vixting, complete as
            informações na{' '}
            <Link
              className="ant-typography-link"
              target="_blank"
              to={{
                pathname: `/${tenant}/opportunities/${jobPostingId}/change/general/`,
              }}
            >
              tela de edição da vaga
            </Link>
            .
          </Typography.Text>
        }
        type="error"
        showIcon
      />
    </Form.Item>
  );
};
export default MissingAdmissionDataAlert;
